export default __webpack_public_path__ + "images/8b5eeddffa157c5e7b9073a56fce1c49.jpg";